import React from "react";
import ReactSwitch from "react-switch";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
 import { setActiveServices } from "../store";

type CustomIconsAssociateModalType = {
    element: any;
    isOneShopClicked:boolean;
    selectedServices:any
};

export function CustomIconsAssociateModal({
    element,
    isOneShopClicked,
    selectedServices,
}: CustomIconsAssociateModalType) {
       const { t } = useTranslation();
    const [serviceState, setServiceState] = React.useState<boolean>(
        isOneShopClicked === true &&
            selectedServices.findIndex(
                (el: any) => el.Id === element.selectedRow.Id
            ) !== -1
            ? selectedServices[
                  selectedServices.findIndex(
                      (el: any) => el.Id === element.selectedRow.Id
                  )
              ].isActive
            : true
    );;

    React.useEffect(() => {
        setActiveServices({
            id: element.selectedRow.Id,
            state: serviceState,
        });
        // eslint-disable-next-line
    }, [serviceState]);

    return (
        <React.Fragment>
            {element.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    <Tooltip
                        title={
                            serviceState === false
                                ? t("Activate")
                                : t("Unactivate")
                        }
                    >
                        <div>
                            <ReactSwitch
                                uncheckedIcon={false}
                                checkedIcon={false}
                                handleDiameter={26}
                                offColor="#f7b4b8"
                                offHandleColor="#E30613"
                                checked={serviceState}
                                onChange={() => {
                                    setServiceState(!serviceState);
                                }}
                                onColor="#c2eddd"
                                onHandleColor="#34C38F"
                                className="srv_icn_AFenableDisable"
                                width={50}
                                height={20}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
